import type { Playbook } from "./types";
// Verticals push their playbooks here (imported for side-effect-free aggregation).
import { emailPlaybooks } from "./playbooks/email";
import { calendarPlaybooks } from "./playbooks/calendar";
import { chatPlaybooks } from "./playbooks/chat";
import { drivePlaybooks } from "./playbooks/drive";

export const PLAYBOOKS: Playbook[] = [
  ...emailPlaybooks,
  ...calendarPlaybooks,
  ...chatPlaybooks,
  ...drivePlaybooks,
];
